import { Box, Skeleton, IconButton } from "@mui/material";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import EditNoteOutlinedIcon from "@mui/icons-material/EditNoteOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const MessageCardSkeleton = () => {
  return (
    <>
     <Box sx={{ display: "flex", gap: 2, mb: 4 }}>
          <Skeleton variant="circular" width={40} height={40} />

          <Box flex={1}>
            {/* Name + Timestamp */}
            <Box
              sx={{ display: "flex", gap: 1, alignItems: "center", mb: 0.5 }}
            >
              <Skeleton variant="text" width="30%" height={20} />
              <Skeleton variant="text" width="20%" height={16} />
            </Box>

            {/* Comment content */}
            <Skeleton variant="text" width="90%" />
            <Skeleton variant="text" width="85%" />
            <Skeleton variant="text" width="70%" />

            {/* Optional: Image block */}
            <Skeleton
              variant="rectangular"
              height={80}
              sx={{ borderRadius: 1, mt: 1 }}
            />

            {/* Footer buttons */}
            <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
              {[EmojiEmotionsIcon, EditNoteOutlinedIcon, DeleteOutlineIcon].map(
                (Icon, i) => (
                  <IconButton size="small" key={i} disabled>
                    <Icon fontSize="small" />
                  </IconButton>
                )
              )}
            </Box>
          </Box>
        </Box>
    </>
  )
}

export default MessageCardSkeleton